import { Checkbox, Chip, FormControlLabel, Theme, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { ChangeEvent, FC } from "react";
import { AgencyCode, AgencyId, JogId } from "../../../../../reducers/states/agency";
import { customTheme } from "../../../../..";

const useStyles = makeStyles((theme: Theme) => ({
  filter: {
    paddingRight: 0,
    marginRight: 0,
    marginLeft: 0,
  },
  notAvailable: {
    color: theme.palette.error.main,
  },
}));

interface AgencyFilterProps {
  props: {
    label: string;
    selectedFilters: string[];
    agencyId: AgencyId | JogId;
    isFeedDown: boolean;
    tooltip?: string;
    useAgencyColor?: boolean;
    handleAgencySelect: (event: ChangeEvent<HTMLInputElement>) => void;
  };
}

const AgencyFilter: FC<AgencyFilterProps> = ({ props }) => {
  const classes = useStyles();

  const getChipColor = (agencyId: AgencyId) => {
    if (props.useAgencyColor === false) return customTheme.palette.primary.main;

    switch (agencyId) {
      case AgencyCode.KCM: {
        return customTheme.agency.KCM;
      }
      case AgencyCode.SFD: {
        return customTheme.agency.SFD;
      }
      case AgencyCode.SPD: {
        return customTheme.agency.SPD;
      }
    }

    if ((agencyId as string).startsWith(AgencyCode.WSP)) {
      return customTheme.agency.WSP;
    }

    return customTheme.palette.primary.main;
  };

  return (
    <FormControlLabel
      className={classes.filter}
      control={
        <Tooltip title={props.tooltip ?? undefined}>
          <Checkbox
            name={props.agencyId as string}
            value={props.agencyId}
            checked={props.selectedFilters.includes(props.agencyId as string)}
            onChange={props.handleAgencySelect}
            checkedIcon={
              <Chip
                style={{ backgroundColor: getChipColor(props.agencyId), color: "white" }}
                variant="filled"
                label={props.label}
              />
            }
            icon={<Chip variant="outlined" label={props.label} />}
            sx={{ padding: "5px" }}
          />
        </Tooltip>
      }
      label={
        props.isFeedDown ? (
          <Tooltip
            title={
              props.label +
              "'s data feed is currently down or experiencing problems. The system will check for updates in 30 seconds"
            }
          >
            <HighlightOffIcon className={classes.notAvailable} />
          </Tooltip>
        ) : (
          undefined
        )
      }
    />
  );
};

export default AgencyFilter;
